module.exports = __webpack_public_path__ + "img/logo-shiba888.172e6139.png";